import React from "react";
import { companyInfo } from "../mock";
import { LegalLayout, H2, H3, P, UL, InfoCard } from "./LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      subtitle="Informationen zur Verarbeitung personenbezogener Daten nach Art. 13 DSGVO"
      testId="datenschutz-page"
    >
      <InfoCard label="Verantwortlicher">
        Haustechnik Service Janzen (HTS Janzen Hausverwaltung)
        <br />
        Inhaber: Simon Janzen
        <br />
        {companyInfo.address.street}, {companyInfo.address.zip} {companyInfo.address.city}
        <br />
        Telefon: {companyInfo.phone} · E-Mail:{" "}
        <a href={`mailto:${companyInfo.email}`} className="underline">
          {companyInfo.email}
        </a>
      </InfoCard>

      <H2>1. Überblick</H2>
      <P>
        Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir verarbeiten personenbezogene Daten
        ausschließlich im Rahmen der gesetzlichen Bestimmungen, insbesondere der
        Datenschutz-Grundverordnung (DSGVO), des Bundesdatenschutzgesetzes (BDSG) und des
        Telekommunikation-Digitale-Dienste-Datenschutz-Gesetzes (TDDDG). Diese Erklärung informiert
        Sie darüber, welche Daten wir beim Besuch dieser Website und bei der Kontaktaufnahme erheben
        und wie wir sie verwenden.
      </P>

      <H2>2. Hosting und Server-Logfiles</H2>
      <P>
        Diese Website wird bei einem externen Dienstleister gehostet. Beim Aufruf der Seite
        verarbeitet der Hosting-Anbieter automatisch Informationen in sogenannten Server-Logfiles,
        die Ihr Browser übermittelt:
      </P>
      <UL
        items={[
          "IP-Adresse des anfragenden Endgeräts",
          "Datum und Uhrzeit des Zugriffs",
          "aufgerufene Seite / Name der abgerufenen Datei",
          "Browsertyp, Browserversion und verwendetes Betriebssystem",
          "Referrer-URL (zuvor besuchte Seite)",
        ]}
      />
      <P>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der
        technisch fehlerfreien Darstellung und der Sicherheit der Website. Die Logfiles werden nach
        kurzer Zeit automatisch gelöscht.
      </P>

      <H2>3. Kontaktformular und Kontaktaufnahme</H2>
      <P>
        Wenn Sie uns über das Kontaktformular, per E-Mail oder Telefon kontaktieren, verarbeiten wir
        die von Ihnen mitgeteilten Daten (Name, E-Mail-Adresse, ggf. Telefonnummer, Betreff und
        Nachricht) zur Bearbeitung Ihrer Anfrage und für mögliche Anschlussfragen.
      </P>
      <H3>Ablauf der Verarbeitung</H3>
      <UL
        items={[
          "Ihre Angaben werden verschlüsselt (TLS) an unseren Server übertragen und dort in einer Datenbank gespeichert, damit Ihre Anfrage nicht verloren geht.",
          "Zusätzlich wird eine E-Mail mit Ihren Angaben an unser Postfach s.janzen@hts-janzen.de zugestellt und eine Eingangsbestätigung an Ihre E-Mail-Adresse gesendet. Der Versand erfolgt über den Mailserver unseres E-Mail-Anbieters Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Zypern (EU), als Auftragsverarbeiter nach Art. 28 DSGVO.",
        ]}
      />
      <P>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Durchführung vorvertraglicher Maßnahmen bzw.
        Vertragserfüllung) sowie, soweit Sie die Einwilligung im Formular erteilen, Art. 6 Abs. 1
        lit. a DSGVO. Ihre Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.
        Die Daten werden gelöscht, sobald sie für die Bearbeitung Ihrer Anfrage nicht mehr
        erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </P>

      <H3>Kontakt über WhatsApp</H3>
      <P>
        Auf unserer Website bieten wir einen Link zu WhatsApp an. Erst wenn Sie diesen Link
        aktiv anklicken, öffnet sich WhatsApp (WhatsApp Ireland Limited, 4 Grand Canal Square,
        Dublin 2, Irland). Durch das bloße Aufrufen unserer Website werden keine Daten an WhatsApp
        übertragen. Für die Kommunikation über WhatsApp gelten die Datenschutzbestimmungen von
        WhatsApp. Rechtsgrundlage für die Bearbeitung Ihrer Anfrage ist Art. 6 Abs. 1 lit. b DSGVO.
        Bitte übermitteln Sie über WhatsApp keine sensiblen Dokumente; nutzen Sie dafür E-Mail oder
        den Postweg.
      </P>

      <H2>4. Google-Bewertungen (Google Places API)</H2>
      <P>
        Auf unserer Startseite zeigen wir öffentliche Kundenbewertungen aus unserem
        Google-Unternehmensprofil an. Diese Bewertungen werden nicht in Ihrem Browser, sondern von
        unserem Server über die Google Places API abgerufen und zwischengespeichert. Dabei werden
        keine personenbezogenen Daten von Ihnen als Website-Besucher an Google übermittelt.
      </P>
      <P>
        Die angezeigten Profilbilder der bewertenden Personen werden von Google-Servern
        (googleusercontent.com) geladen; hierbei kann Ihre IP-Adresse an Google Ireland Limited,
        Gordon House, Barrow Street, Dublin 4, Irland, übermittelt werden. Rechtsgrundlage ist Art. 6
        Abs. 1 lit. f DSGVO (berechtigtes Interesse an der authentischen Darstellung von
        Kundenmeinungen). Weitere Informationen:{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noreferrer"
          className="underline text-brand-900"
        >
          https://policies.google.com/privacy
        </a>
        . Wenn Sie den Links „Auf Google ansehen“ oder „Jetzt auf Google bewerten“ folgen, verlassen
        Sie unsere Website; es gelten dann die Datenschutzbestimmungen von Google.
      </P>

      <H2>5. Kartendarstellung (OpenStreetMap)</H2>
      <P>
        Zur Anzeige unseres Standorts binden wir eine Karte der OpenStreetMap Foundation (St John's
        Innovation Centre, Cowley Road, Cambridge, CB4 0WS, Vereinigtes Königreich) ein. Beim Laden
        der Karte wird Ihre IP-Adresse an die Server der OpenStreetMap Foundation übermittelt.
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO; unser berechtigtes Interesse liegt in der
        anschaulichen Darstellung unseres Standorts. Datenschutzhinweise:{" "}
        <a
          href="https://wiki.osmfoundation.org/wiki/Privacy_Policy"
          target="_blank"
          rel="noreferrer"
          className="underline text-brand-900"
        >
          https://wiki.osmfoundation.org/wiki/Privacy_Policy
        </a>
        .
      </P>

      <H2>6. Bilder von Drittanbietern</H2>
      <P>
        Einzelne Bilder auf dieser Website werden vom Dienst Unsplash (Unsplash Inc., 500-400
        Rue McGill, Montréal, QC H2Y 2G1, Kanada) geladen. Dabei wird Ihre IP-Adresse an Unsplash
        übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Für Kanada besteht ein
        Angemessenheitsbeschluss der EU-Kommission.
      </P>

      <H2>7. Cookies und Tracking</H2>
      <P>
        Diese Website verwendet <strong>keine</strong> Tracking- oder Analyse-Dienste (z. B. Google
        Analytics) und setzt keine Cookies zu Werbe- oder Analysezwecken. Es werden lediglich
        technisch notwendige Speichervorgänge im Browser vorgenommen, die für den Betrieb der Seite
        erforderlich sind (§ 25 Abs. 2 Nr. 2 TDDDG).
      </P>

      <H2>8. Ihre Rechte</H2>
      <P>Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden Daten:</P>
      <UL
        items={[
          "Recht auf Auskunft (Art. 15 DSGVO)",
          "Recht auf Berichtigung (Art. 16 DSGVO)",
          "Recht auf Löschung (Art. 17 DSGVO)",
          "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
          "Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
          "Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO)",
          "Recht auf Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)",
        ]}
      />
      <P>
        Zur Ausübung Ihrer Rechte genügt eine E-Mail an{" "}
        <a href={`mailto:${companyInfo.email}`} className="underline text-brand-900">
          {companyInfo.email}
        </a>
        . Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Für
        uns zuständig ist die Landesbeauftragte für Datenschutz und Informationsfreiheit
        Nordrhein-Westfalen, Kavalleriestraße 2–4, 40213 Düsseldorf,{" "}
        <a
          href="https://www.ldi.nrw.de"
          target="_blank"
          rel="noreferrer"
          className="underline text-brand-900"
        >
          www.ldi.nrw.de
        </a>
        .
      </P>

      <H2>9. Datensicherheit</H2>
      <P>
        Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
        Inhalte eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am
        „https://“ in der Adresszeile und am Schloss-Symbol Ihres Browsers.
      </P>

      <H2>10. Aktualität dieser Datenschutzerklärung</H2>
      <P>
        Diese Datenschutzerklärung hat den Stand Juni 2026. Durch die Weiterentwicklung unserer
        Website oder aufgrund geänderter gesetzlicher Vorgaben kann eine Anpassung erforderlich
        werden. Die jeweils aktuelle Fassung finden Sie stets auf dieser Seite.
      </P>
    </LegalLayout>
  );
}
